/**
 * Only same-app relative paths. Rejects protocol-relative and absolute URLs so a
 * crafted location state cannot send someone off-site after two-factor setup.
 */
export const isSafeReturnTo = (value: unknown): value is string =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');
